var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c(
                            "gg-card-header",
                            [
                              _vm._v(" Bandwidth History "),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "float-right",
                                  attrs: {
                                    secondary: "",
                                    loading: _vm.graphs_loading
                                  },
                                  on: {
                                    click: _vm.updateGraphs
                                  }
                                },
                                [_vm._v(" Refresh ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "gg-card-text",
                            [
                              _c("v-img", {
                                attrs: {
                                  src: _vm.bandwidthGraph,
                                  "max-height": "200",
                                  contain: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c(
                            "gg-card-header",
                            [
                              _vm._v(" Load History "),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "float-right",
                                  attrs: {
                                    secondary: "",
                                    loading: _vm.graphs_loading
                                  },
                                  on: {
                                    click: _vm.updateGraphs
                                  }
                                },
                                [_vm._v(" Refresh ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "gg-card-text",
                            [
                              _c("v-img", {
                                attrs: {
                                  src: _vm.loadGraph,
                                  "max-height": "200",
                                  contain: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c(
                            "gg-card-header",
                            [
                              _vm._v(" Memory History "),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "float-right",
                                  attrs: {
                                    secondary: "",
                                    loading: _vm.graphs_loading
                                  },
                                  on: {
                                    click: _vm.updateGraphs
                                  }
                                },
                                [_vm._v(" Refresh ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "gg-card-text",
                            [
                              _c("v-img", {
                                attrs: {
                                  src: _vm.memoryGraph,
                                  "max-height": "200",
                                  contain: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }